import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

import RubriqueService from "../service/RubriqueSevice";
import ArticleService from "../service/Article";
import {Partenaires} from "./Home/Partenaires";
import {urlBase} from "../config/Globals";
import maison from "../assets/images/maison.svg";
import OtherArticles from "./Rubrique/OtherArticles";

export const Article = ({plus}) => {

    const { wording,id } = useParams();

    const[rubrique, setRubrique] = useState([]);
    const[loadingRubrique, setLoadingRubrique] = useState(1);
    const fetchRubrique = async(wording) => {
        try {
            setLoadingRubrique(true);
            const data = await RubriqueService.find(wording);
            setRubrique(data);
        } catch (error) {
            console.error("Erreur lors de la récup de la rubrique", error);
        } finally {
            setLoadingRubrique(false);
        }
    }
    useEffect(() => {
        fetchRubrique(wording);
    }, [wording]);

    const[article, setArticle] = useState([]);
    const[loadingArticle, setLoadingArticle] = useState(1);
    const fetchArticle = async(id) => {
        try{
            const data = await ArticleService.find(id);
            setArticle(data);
            setLoadingArticle(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchArticle(id);
    }, [id]);



    const[articles, setArticles] = useState([]);
    const[loadingArticles, setLoadingArticles] = useState(1);
    const fetchArticles = async(id) => {
        try {
            setLoadingArticles(true);
            const data = await ArticleService.findAllInRubrique(id);
            setArticles(data);
        } catch (error) {
            console.error("Erreur lors de la récup des articles", error);
        } finally {
            setLoadingArticles(false);
        }
    }
    useEffect(() => {
        if (rubrique && rubrique.id) {
            fetchArticles(rubrique.id);
        }
    }, [rubrique?.id]);

    return (
        <>
            <Helmet>
                <title>{article.titre}</title>
                <meta name="description" content={article.resume}/>
            </Helmet>
            <main class="type que-dit-la-recherche">
                <section className="bg-gris">
                    <div className="container px-4 pb-2 position-relative z-1">
                        <div className="row justify-content-center text-center pt-lg-4 pb-4 pb-lg-5 position-relative z-1">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb justify-content-center">
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase} className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree'}
                                               className="breadcrumb-link">
                                                Tout savoir sur la flavescence dorée
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree/'+rubrique.wording} className="breadcrumb-link">{rubrique.titre}</a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            {article.titre}
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12 col-lg-7">
                                <h1 className="display-5 fw-sb mb-3">{article.titre}</h1>
                                <div className="fs-6 text-marron">
                                    <p>Publié le {article.date_publication && new Date(article.date_publication).toLocaleDateString('fr-FR')}</p>
                                </div>
                                <span className="btn btn-outline-custom disabled text-uppercase mt-2 d-inline-flex">{article.encart_gris}</span>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="bg-white">
                    <div className="container px-4 py-4 py-lg-5 position-relative z-1">
                        <div className="row g-5 justify-content-center">
                            <div className="col-12 col-lg-8 col-xxl-6" dangerouslySetInnerHTML={{__html : article.contenu}}>

                            </div>
                        </div>
                    </div>
                </section>
                <OtherArticles articles={articles} articleId={id} plus={plus} />
                <Partenaires />
            </main>
        </>
    )
}